import { fetchCSRFToken } from "../csrf";

/**
 * Force a form to wait until the CSRF token is fetched
 * @param {Node} el <form> element to force to wait
 */
export default function waitForCsrf(el, options) {
  if (el.nodeName === "FORM") {
    el.addEventListener("submit", onSubmit);
  }

  function onSubmit(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    fetchCSRFToken().then(csrfToken => {
      el.removeEventListener("submit", onSubmit);
      el.submit();
    });
    return false;
  }
}
